import React from "react";

export default function AddToCart({ addToCart, totalPrice, disabled }) {
  return (
    <div className="uploadButton">
      <p id="confirmation_text">
        By submitting my order, I accept that my Print will be printed exactly
        as shown on this page.
      </p>
      <button
        className="addToCart"
        id="add-to-cart"
        onClick={addToCart}
        disabled={disabled ? "disabled" : ""}
      >
        Add to Cart {totalPrice && `($${totalPrice})`}
      </button>
    </div>
  );
}
